import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import ListMeetingView from '../views/Meetings/ListMeeting.vue'
import DashboardView from '../views/Dashboard.vue'
import SettingsView from '../views/Settings.vue'
import CreateMeetingView from '../views/Meetings/CreateMeeting.vue'
import CallbackThaid from '../views/CallbackThaid.vue'
import CallbackAzure from '../views/CallbackAzure.vue'
import PrivacyPolicy from '../views/PrivacyPolicy.vue'
import TermCondition from '../views/TermCondition.vue'
import CreateUserView from '../views/Users/CreateUser.vue'
import ListUserView from '../views/Users/ListUser.vue'
import Login from '../components/Login.vue';
import store from '@/store';

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Login,
    meta: { guestOnly: true }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { guestOnly: true }
  },
  {
    path: '/logout',
    name: 'Logout',
    beforeEnter: (to, from, next) => {
      store.dispatch('logout').then(() => {
        next('/login'); 
      });
    }
  },
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { requiresAuth: true }
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: DashboardView,
    meta: { requiresAuth: true }
  },
  {
    path: '/settings',
    name: 'settings',
    component: SettingsView,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/listmeeting',
    name: 'Listmeeting',
    component: ListMeetingView,
    meta: { requiresAuth: true }
  },
  {
    path: '/createmeeting',
    name: 'createmeeting',
    component: CreateMeetingView,
    meta: { requiresAuth: true }
  },
  {
    path: "/callback/thaid",
    name: "CallbackThaid",
    component: CallbackThaid,
  },
  {
    path: "/callback/azure",
    name: "CallbackAzure",
    component: CallbackAzure,
  },
  {
    path: "/privacypolicy",
    name: "privacyPolicy",
    component: PrivacyPolicy,
  },
  {
    path: "/termcondition",
    name: "termCondition",
    component: TermCondition,
  },
  {
    path: "/createuser",
    name: "createuser",
    component: CreateUserView,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: "/listuser",
    name: "listuser",
    component: ListUserView,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  // login อยู่ = มีข้อมูลผู้ใช้และ token (ไม่มี token = เรียก API ไม่ได้ ต้อง login ใหม่)
  const loggedIn = store.getters.isLoggedIn ? store.state.user : null;
  
  if (to.matched.some(record => record.meta.requiresAuth) && !loggedIn) {
    next('/login');
  } else if (to.matched.some(record => record.meta.requiresAdmin) && loggedIn.admin !== 1) {
    // หน้าเฉพาะแอดมิน: ผู้ใช้ทั่วไปเข้าผ่าน URL ตรงๆ ไม่ได้
    next('/listmeeting');
  } else if (to.matched.some(record => record.meta.guestOnly) && loggedIn) {
    // login อยู่แล้ว: ไม่ต้องเห็นหน้า login อีก พาไปหน้าแรก (ปฏิทินการประชุม)
    next('/dashboard');
  } else {
    next();
  }
});

export default router
